import { Flex, SideEnum } from '@talos/kyoko';
import styled from 'styled-components';
import { ORDER_BOOK_ITEM_HEIGHT } from '../../containers/Trading/DeepDive/dimensions';

export const Cell = styled(Flex)<{ textAlign?: string }>`
  border-top: ${({ theme }) => `1px solid ${theme.borderColorBlotterTable}`};
  flex: 1 1 0;
  font-size: ${({ theme }) => theme.fontSizeSmall}rem;
  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};
  position: relative;
  z-index: 2;
  width: 0;
`;

Cell.defaultProps = {
  p: 'spacing8',
};

export const Row = styled.div<{ clickable?: boolean; noTopBorder?: boolean; previewActive?: boolean; side?: SideEnum }>`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'normal')};
  display: flex;
  height: ${ORDER_BOOK_ITEM_HEIGHT}px;
  min-height: ${ORDER_BOOK_ITEM_HEIGHT}px;
  position: relative;

  &:hover {
    background: ${({ theme, clickable, previewActive, side }) =>
      previewActive
        ? side === SideEnum.Buy
          ? theme.colors.green.dim
          : theme.colors.red.dim
        : clickable
          ? `${theme.colors.gray['020']}`
          : `inherit`};
  }

  ${Cell} {
    ${({ noTopBorder }) => noTopBorder && `border-top: 0`};
  }
`;

export const Indicator = styled.div<{ side: SideEnum }>`
  background: ${({ theme, side }) =>
    side === SideEnum.Sell ? theme.colorTextNegativeMuted : theme.colorTextPositiveMuted};
  content: '';
  height: 8px;
  position: absolute;
  left: 0;
  top: 11px;
  z-index: 1;
`;

export const Header = styled(Flex)<{ uppercase?: boolean }>`
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.borderColorBlotterTable}`};
  flex: 1;
  font-size: ${({ theme }) => theme.fontSizeTiny}rem;
  line-height: 1;
  ${({ uppercase }) => uppercase && `text-transform: uppercase;`}
`;

Header.defaultProps = {
  p: 'spacing8',
};

export const MiddleRowWrapper = styled(Flex)`
  border: ${({ theme }) => `1px solid ${theme.borderColorBlotterTable}`};
  border-width: 1px 0;
`;
MiddleRowWrapper.defaultProps = {
  h: ORDER_BOOK_ITEM_HEIGHT,
  px: 'spacing12',
  py: 'spacing4',
  gap: 'spacing8',
  alignItems: 'center',
  background: 'colors.gray.020',
};

export const OwnOrderIndicator = styled.div`
  position: absolute;
  z-index: 3;
`;
